<template>
  <v-dialog v-model="dialog" persistent width="800">
    <v-card>
      <v-toolbar color="primary" dark>
        <v-toolbar-title>Reset Password</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="dialog = false"><v-icon>mdi-close</v-icon></v-btn>
      </v-toolbar>
      <v-card-text>
        <div class="py-5">
          <v-form @submit.prevent data-vv-scope="form" lazy-validation>
            <v-row>
              <v-col cols="12" sm="12" md="12" lg="12" class="py-0">
                <label class="caption mb-2">Password Baru</label>
                <v-text-field
                  :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                  :type="show1 ? 'text' : 'password'"
                  @click:append="show1 = !show1"
                  dense
                  single-line
                  outlined
                  class="mt-3"
                  ref="password"
                  label="Kata Sandi baru"
                  v-model="form.password_new"
                  hint="Isi ulang kata sandi baru"
                  data-vv-name="password"
                  data-vv-as="Kata Sandi baru"
                  v-validate="'required|min:6'"
                  :error-messages="errors.collect('form.password')"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="12" lg="12" class="py-0">
                <label class="caption mb-2">Password Konfirmasi</label>
                <v-text-field
                  :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
                  :type="show2 ? 'text' : 'password'"
                  @click:append="show2 = !show2"
                  dense
                  single-line
                  outlined
                  label="Konfirmasi kata sandi baru"
                  v-model="form.password_new_confirmation"
                  hint="Konfirmasi kata sandi baru"
                  data-vv-name="password_confirmation"
                  data-vv-as="Konfirmasi kata sandi baru"
                  v-validate="'required|min:6|confirmed:password'"
                  :error-messages="errors.collect('form.password_confirmation')"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="12">
                <div class="text-right">
                  <v-btn color="primary" depressed @click="save">Simpan</v-btn>
                </div>
              </v-col>
            </v-row>
          </v-form>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  $_veeValidate: {
    validator: 'new',
  },
  props: {
    api: {
      type: String,
      default: 'pemantau/resetPassword'
    }
  },
  data() {
    return {
      show1: false,
      show2: false,
      form: {},
      dialog: false,
      id: null,
    }
  },
  methods: {
    open({ id }) {
      this.id = id
      this.reset()
      this.dialog = true
    },

    reset() {
      this.$validator.reset()
      this.form = {}
      this.show1 = false
      this.show2 = false
    },

    save() {
      this.$validator
        .validateAll('form')
        .then((res) => {
          if (!res) return Promise.reject()
          return res
        })
        .then(() => {
          this.$store
            .dispatch(this.api, Object.assign({}, this.form, { user_id: this.id }))
            .then(() => {
              this.$success('Aksi berhasil dilakukan')
              this.$emit('reload')
              this.dialog = false
            })
            .catch((err) => {
              this.$error(err)
            })
        })
    },
  },
}
</script>
